import { useUpdateEffect } from 'react-use';
import { usePrevious } from 'react-use';

export const useOnChange = (value: any, callback: () => void) => {
  const prevValue = usePrevious(value);

  useUpdateEffect(() => {
    if (value !== prevValue) {
      callback();
    }
  }, [value, prevValue]);
};
